import { render, staticRenderFns } from "./club-super-share.vue?vue&type=template&id=3a61cb74&scoped=true&"
import script from "./club-super-share.vue?vue&type=script&lang=js&"
export * from "./club-super-share.vue?vue&type=script&lang=js&"
import style0 from "./club-super-share.vue?vue&type=style&index=0&id=3a61cb74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61cb74",
  null
  
)

export default component.exports